export var categorizePhotos = function (photos) {
    var selfie = photos.find(function (p) { return p.photoType === "YOU"; });
    var passport = photos.find(function (p) { return p.photoType === "PASSPORT"; });
    var front = photos.find(function (p) { return p.photoType === "FRONT"; });
    var back = photos.find(function (p) { return p.photoType === "BACK"; });
    var idCards = photos.filter(function (p) { return p.photoType === "ID_CARD"; });
    if (passport) {
        return { selfie: selfie, docPhotos: [passport], docType: "PASSPORT" };
    }
    if (front || back) {
        return {
            selfie: selfie,
            docPhotos: [front, back].filter(Boolean),
            docType: "FRONT_BACK",
        };
    }
    if (idCards.length > 0) {
        return { selfie: selfie, docPhotos: idCards, docType: "ID_CARD" };
    }
    return { selfie: selfie, docPhotos: [], docType: "UNKNOWN" };
};
